module.exports = __webpack_public_path__ + "static/economy-00bdfe837d619e5a3e259ab93a4160a3.svg";